import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withModifiers as _withModifiers, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "checkout-steps-nav__step-indicator" }
const _hoisted_2 = { class: "checkout-steps-nav__step-label" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["checkout-steps-nav__entry", _ctx.classes]),
    onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_ctx.$emit('click')), ["prevent"]))
  }, [
    _createElementVNode("span", _hoisted_1, _toDisplayString(_ctx.step + 1) + ". ", 1),
    _createElementVNode("span", _hoisted_2, _toDisplayString(_ctx.title), 1)
  ], 2))
}